import {
  Component,
  OnInit,
  ViewEncapsulation,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
} from '@angular/core';
import { RoutePath } from 'src/app/app-routing.module';
import { LocalizationService } from 'src/app/service/localization.service';
import { JsonKey } from 'src/app/data/type/locale-copy-key';
import { PostMessageId } from 'src/app/data/type/post-message-id';
import isMobile from 'src/app/utils/is-mobile';
import { getWelcomePageCopy } from 'src/app/utils/localization';
import { Parameter } from 'src/app/data/type/parameter';
import { RotationService } from 'src/app/service/rotation.service';
import { IntroPageAnimation } from './animations';
import { ActivatedRoute } from '@angular/router';
import { triggerEvent, AnalyticsEvent } from 'src/app/utils/analytics';
import { CompareButtonLocation } from 'src/app/component/atoms/a02-comparison-button/a02-comparison-button.component';
import { ParameterService } from 'src/app/service/parameter.service';
import { Brand } from 'src/app/data/enum/brand';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-p01-intro-page',
  templateUrl: './p01-intro-page.component.html',
  styleUrls: ['./p01-intro-page.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class P01IntroPageComponent implements OnInit {
  @ViewChild('buttonsContainer') buttonsContainerRef: ElementRef;

  public readonly jsonKey = JsonKey;
  public customClass = 'clase-custom';
  public copy = {
    [JsonKey.WELCOME_PRIMARY_BUTTON_COPY]: '',
    [JsonKey.WELCOME_SECONDARY_BUTTON_3P_COPY]: '',
    [JsonKey.WELCOME_PRIMARY_BUTTON_ARIA_LABEL]: '',
  };
  private buttonsContainerElement: HTMLDivElement | null = null;
  public compareButtonLocation = CompareButtonLocation.intro;
  public isMobile: boolean = isMobile();
  public showLearnMore: boolean;
  public showCompareButton: boolean = this.parameterService.showCompareButton();
  public isValidAndNonGenericBrand = false;
  public hasCustomCTA = !!(
    this.parameterService.getParam(Parameter['custom-cta-href']) &&
    this.parameterService.getParam(Parameter['custom-cta-label'])
  );

  public webpLogoAssetUrl = '';
  public pngLogoAssetUrl = '';
  public webpBrandAssetUrl = '';
  public pngBrandAssetUrl = '';
  public brand = '';

  constructor(
    private parameterService: ParameterService,
    private localizationService: LocalizationService,
    private route: ActivatedRoute,
    public rotationService: RotationService,
    private introPageAnimation: IntroPageAnimation,
    private changeDetector: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.brand = this.parameterService.getParam(Parameter.brand);
    const brandName = this.brand && Brand[this.brand] ? this.brand : 'chromecast';

    this.isValidAndNonGenericBrand = !!Brand[brandName] && brandName !== Brand.all;
    this.showLearnMore = this.route.snapshot.queryParams[Parameter['show-learn-more']] === 'true';
    this.copy = getWelcomePageCopy(this.localizationService);

    this.pngBrandAssetUrl = `${environment.baseHref}/assets/images/p01-intro-page/product-${brandName}.png`;
    this.webpBrandAssetUrl = `${environment.baseHref}/assets/images/p01-intro-page/product-${brandName}.webp`;
    this.pngLogoAssetUrl = this.rotationService.isLandscape
      ? `${environment.baseHref}/assets/images/p01-intro-page/${brandName}-logo-landscape.png`
      : `${environment.baseHref}/assets/images/p01-intro-page/${brandName}-logo-portrait.png`;
    this.webpLogoAssetUrl = this.rotationService.isLandscape
      ? `${environment.baseHref}/assets/images/p01-intro-page/${brandName}-logo-landscape.webp`
      : `${environment.baseHref}/assets/images/p01-intro-page/${brandName}-logo-portrait.webp`;

    this.rotationService.isLandscapeUpdated.subscribe(this.onOrientationChange.bind(this));
    this.onOrientationChange();
  }

  ngAfterViewInit(): void {
    this.buttonsContainerElement = this.buttonsContainerRef.nativeElement;
    this.setButtonPosition();
  }

  // Not necessary for now as we are now allowing mobile portrait.
  // Keeping in codebase in case of rollback for 3rd party sites.
  onOrientationChange() {
    this.setButtonPosition();

    //   if (!isMobile()) return;
    //   const playAnimation =
    //     this.rotationService.isLandscape && this.rotationService.getShowRotationScreen();
    //   const killAnimation =
    //     !this.rotationService.isLandscape &&
    //     this.introPageAnimation.animation &&
    //     this.introPageAnimation.animation.isActive();
    //   if (playAnimation) {
    //     setTimeout(this.playAnimation.bind(this), 10, false);
    //   } else if (killAnimation) {
    //     this.introPageAnimation.animation.kill();
    //   }
  }

  private playAnimation(animateContent: boolean = true) {
    this.introPageAnimation.play(
      () => {
        this.localizationService.localizedNavigate(RoutePath['browse-titles']);
      },
      animateContent,
      this.rotationService.isLandscape,
    );
  }

  public onPrimaryButtonClick() {
    this.playAnimation();
    triggerEvent(AnalyticsEvent.interactClick);
  }

  private setButtonPosition() {
    if (!this.buttonsContainerElement) return;
    this.changeDetector.detectChanges();

    if (this.buttonsContainerElement.children.length <= 1) {
      this.buttonsContainerElement.firstElementChild.classList.add('no-compare');
    } else {
      this.buttonsContainerElement.firstElementChild.classList.remove('no-compare');
    }
  }

  public on3PSecondaryButtonClick() {
    window.parent?.postMessage(PostMessageId.LEARN_MORE, '*' /*, 'http://someURl.com' */);
  }
}
